module.exports = __webpack_public_path__ + "static/media/ao.6e4ec944.svg";